@if (productItem(); as productItem) {
  <ui-product-line-item
    [productItem]="productItem"
    [quantityCounterControl]="quantityCounterControl"
    [attributesTemplate]="attributes"
    [position]="position()"
    [showRemove]="false"
    [readonly]="!canReorder()"
    [priceOverride]="priceOverride()"
    [showCheckbox]="showCheckbox()"
    [selectable]="!isUnavailable()"
    [(selected)]="selected"
    [unavailable]="isUnavailable() && canReorder()"
  ></ui-product-line-item>
} @else {
  <div class="order-item-partial">
    <span class="product-name">{{ orderItemProductName() }}</span>

    <ng-container [ngTemplateOutlet]="attributes"></ng-container>

    @if (canReorder()) {
      <ui-product-not-orderable></ui-product-not-orderable>
    }
  </div>
}

<ng-template #attributes>
  <div class="order-item-details">
    <mat-list class="order-item-details-list">
      <mat-list-item>
        <span matListItemTitle>Art.Nr:
          @if (!orderItem().isFree) {
            {{ orderItem().sku }}
          }
        </span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle>VE:
          @if (orderItem().productData?.details?.packagingUnit) {
            {{ orderItem().productData!.details!.packagingUnit }}
          } @else {
            k.A.
          }
        </span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle>Lieferdatum:
          @if (orderItem().deliveryAt) {
            {{ orderItem().deliveryAt | luxonDate }}
          } @else {
            k.A.
          }
        </span>
      </mat-list-item>
      <mat-list-item
        [class.not-available]="isUnavailable()"
        [class.partially-available]="isPartiallyAvailable()"
      >
        <span matListItemTitle>Anzahl:
          @if (isUnavailable() || isPartiallyAvailable()) {
            {{ orderItem().amountDelivered }} von {{ orderItem().amountOrdered }} verfügbar
          } @else {
            {{ orderItem().amountDelivered }}
          }
        </span>
      </mat-list-item>
    </mat-list>
  </div>
</ng-template>
